/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-11-01 11:26:57
 * @LastEditTime: 2026-05-06 23:56:26
 * @Description:
 */
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import MarketSection from './components/MarketSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CalendarSection from './components/CalendarSection';
import MT5Section from './components/MT5Section';
import HomeAwardAnnouncement from './components/HomeNoticePopup';
import PartnersSection from './components/PartnersSection';
import AwardsMarquee from './components/AwardsMarquee';
import ChineseSeoContent from '../../components/seo/ChineseSeoContent';

import { useIsHongKongIp } from '../../hooks/useIsHongKongIp';

export default function Home() {
  const { canShowRestrictedContent } = useIsHongKongIp();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main>
        <HeroSection />
        <HomeAwardAnnouncement />
        <AwardsMarquee />
        <FeaturesSection />
        <ChineseSeoContent />
        <MarketSection />
        <CalendarSection />

        {/* 香港 / 美國 IP 不顯示 */}
        {canShowRestrictedContent && <MT5Section />}

        <PartnersSection />
        <TestimonialsSection />
      </main>

      <Footer />
    </div>
  );
}
